module.exports = __webpack_public_path__ + "assets/ff14a21246ad8fbc3c3c1d9ce9644511.mp3";